import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={22}
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M8 0C3.589 0 0 3.574 0 7.968c0 5.452 7.16 13.456 7.464 13.794a.723.723 0 001.072 0C8.841 21.424 16 13.42 16 7.968 16 3.574 12.411 0 8 0zm0 11.976c-2.22 0-4.025-1.798-4.025-4.008S5.781 3.958 8 3.958c2.22 0 4.025 1.8 4.025 4.01S10.219 11.976 8 11.976z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
